import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  "aria-label": "breadcrumb"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "ni ni-box-2"
}, null, -1);
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("ol", {
    class: _normalizeClass(`px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb ${!_ctx.isRTL ? 'me-sm-6' : ' '}`)
  }, [_createElementVNode("li", {
    class: _normalizeClass(`text-sm breadcrumb-item ${_ctx.isRTL ? 'ps-2' : ''}`)
  }, [_createElementVNode("a", {
    class: _normalizeClass(_ctx.isNavFixed ? 'text-dark' : 'text-white')
  }, _hoisted_3, 2)], 2), _createElementVNode("li", {
    class: _normalizeClass(`text-sm breadcrumb-item  ${_ctx.isNavFixed ? 'text-dark' : 'text-white'}`)
  }, [_ctx.isRTL ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: _normalizeClass(`opacity-8 ps-2 ${_ctx.isNavFixed ? 'text-dark' : 'text-white'}`),
    href: "#"
  }, "لوحات القيادة", 2)) : (_openBlock(), _createElementBlock("a", {
    key: 1,
    class: _normalizeClass(`${_ctx.isNavFixed ? 'text-dark' : 'text-white'}`),
    href: "#"
  }, _toDisplayString($props.currentDirectory), 3))], 2), _createElementVNode("li", {
    class: _normalizeClass(`text-sm breadcrumb-item active ${_ctx.isNavFixed ? 'text-dark' : 'text-white'}`),
    "aria-current": "page"
  }, _toDisplayString($props.currentPage), 3)], 2), _createElementVNode("h6", {
    class: _normalizeClass(`mb-0 font-weight-bolder ${_ctx.isNavFixed ? 'text-dark' : 'text-white '}`)
  }, _toDisplayString($props.currentPage), 3)]);
}